export default function PromptCratePrivacy() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Privacy Policy - PromptCrate
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Effective date: <time dateTime="2026-05-29">May 29, 2026</time>
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <p>
            <strong>Cosmovex</strong> built the <strong>PromptCrate</strong> app
            as an ad-supported utility. This Privacy Policy explains what
            information may be collected and how it may be used when you use the
            app.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Information We Collect
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>No account creation:</strong> The app does not require
              sign-in and does not collect usernames or passwords.
            </li>
            <li>
              <strong>Your prompts stay local:</strong> The prompts you save,
              create, edit, favorite, and the values you enter when filling
              variables are stored locally on your device. They are not uploaded
              to our servers unless you explicitly copy or share them yourself.
            </li>
            <li>
              <strong>Usage and diagnostics:</strong> Basic app usage events,
              crash data, and device diagnostics may be collected to improve
              performance and reliability.
            </li>
            <li>
              <strong>Advertising data:</strong> Ad identifiers and ad
              interaction signals may be processed by ad partners to serve and
              measure ads.
            </li>
            <li>
              <strong>Purchases:</strong> The one-time Pro upgrade is processed
              by Google Play Billing. We do not receive or store your payment
              card details.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            How We Use Information
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To operate app features and improve stability.</li>
            <li>To understand product usage through analytics.</li>
            <li>To detect crashes and fix bugs faster.</li>
            <li>To display and measure ads in supported versions of the app.</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Third-Party Services
          </h2>
          <p>PromptCrate may rely on trusted third-party services such as:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Google Play Services</li>
            <li>Google Play Billing</li>
            <li>Firebase Analytics</li>
            <li>Firebase Crashlytics</li>
            <li>Firebase Remote Config</li>
            <li>Google AdMob</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Data Retention</h2>
          <p>
            We do not maintain user accounts for this app. Your prompt library
            lives on your device. Analytics, diagnostics, and advertising data
            are retained by the relevant service providers according to their
            own policies.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Your Choices</h2>
          <p>
            You can limit ad personalization using your device settings and stop
            app data collection by uninstalling the app. Uninstalling also
            removes the prompts stored locally on your device.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Security</h2>
          <p>
            We use reasonable safeguards and trusted infrastructure providers,
            but no method of storage or transmission can be guaranteed to be
            completely secure.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Children&apos;s Privacy
          </h2>
          <p>
            This app is not directed to children under 13, and we do not
            knowingly collect personal information from children.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Changes to This Policy
          </h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            published on this page with a revised effective date.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Us</h2>
          <p>
            For privacy-related questions, contact{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            .
          </p>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
